// Source: https://unicode.org/cldr/trac/browser/trunk/common/main/pt_PT.xml?rev=14409#L491
module["exports"] = {
  wide: ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"],
  abbr: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"]
};